import { AnnotationOptions } from 'chartjs-plugin-annotation';
import { ChartReferenceLine } from '../interfaces/chart-data.interface';

/**
 * 共通のリファレンスラインアノテーションを構築するヘルパー
 */
export function buildReferenceLineAnnotations(
  referenceLines: ChartReferenceLine[],
  defaultColor = 'var(--md-sys-color-error)'
): Record<string, AnnotationOptions> {
  const annotations: Record<string, AnnotationOptions> = {};
  
  referenceLines.forEach((ref, index) => {
    annotations[`refLine${index}`] = {
      type: 'line',
      yMin: ref.value,
      yMax: ref.value,
      borderColor: ref.color || defaultColor,
      borderWidth: 2,
      borderDash: ref.borderDash || [5, 5],
      label: {
        display: true,
        content: ref.label,
        position: 'end',
        backgroundColor: ref.color || defaultColor,
        color: 'var(--md-sys-color-on-error)'
      }
    };
  });

  return annotations;
}
